import { getGeoValue, TGeoValue, TJsonQuery } from '../../../packages/JsonQuery';
import { getUniqGeo } from './getUniqGeo';

export function addDistrictToJsonQuery(jsonQuery: TJsonQuery, id: number): TGeoValue[] {
  const geo = getGeoValue()(jsonQuery);

  if (!geo) {
    return [{ id, type: 'district' }];
  }

  const uniqDistricts = getUniqGeo(geo, [{ id, type: 'district' }]);

  return geo.concat(uniqDistricts);
}
